<template>
	<div
		:class="$style.wrapper"
		v-click-outside="outsideClicked"
	>
		<div
			@click="handleCloseClick"
			v-touch="handleCloseClick"
			:class="$style.closeButtonContainer"
		>
			<CloseButton></CloseButton>
		</div>
		<div :class="$style.instructionsContainer">
			<h1>Instructions</h1>
			<div :class="$style.instructionContainer">1. Select "Residential" or "Commercial".</div>
			<div :class="$style.instructionContainer">2. Tap on a point in each room.</div>
			<div :class="$style.instructionContainer">3. Learn about the best way to remove each hazard.</div>
			<div :class="$style.instructionContainer">4. Hit "continue" to move to the next hazard or room.</div>
		</div>
		<div :class="$style.buttonsContainer">
			<div :class="$style.experienceButtons">
				<HollowButton
					@click.native="handleCommercialClicked"
					v-touch.native="handleCommercialClicked"
					:text="'Commercial'"
					:class="$style.hollowCommercialButton"
				></HollowButton>
				<HollowButton
					@click.native="handleResidentialClicked"
					v-touch.native="handleResidentialClicked"
					:text="'Residential'"
					:class="$style.hollowResidentialButton"
				></HollowButton>
			</div>
			<div :class="$style.winButtonContainer">
				<UiButton
					:class="$style.winButton"
					:buttonText="'Enter to win an emergency preparedness kit from Preppi'"
					:buttonAction="handleWinButtonClick"
				></UiButton>
			</div>
		</div>
	</div>
</template>

<script>
import { TweenMax, TimelineMax } from "gsap";
import HollowButton from "./HollowButton";
import UiButton from "./UiButton";
import vClickOutside from "v-click-outside";
import CloseButton from "./svgs/CloseButton";

export default {
	components: {
		HollowButton,
		UiButton,
		CloseButton
	},
	directives: {
		clickOutside: vClickOutside.directive
	},
	// props: ['outsideClicked'],
	data() {
		return {
			isOpen: false
		};
	},
	mounted() {
		this.$bus.$on("show-instructions-card", this.handleShowCard);

		TweenMax.set("." + this.$style.wrapper, {
			x: "-=100%"
		});
	},
	methods: {
		handleCloseClick() {
			this.$bus.$emit("hide-full-overlay");

			TweenMax.to("." + this.$style.wrapper, 0.5, {
				x: "-=100%",
				ease: Power4.easeOut,
				onComplete: () => {
					this.isOpen = false;
				}
			});
		},
		handleShowCard() {
			TweenMax.to("." + this.$style.wrapper, 0.5, {
				x: "+=100%;",
				ease: Power4.easeOut,
				onComplete: () => {
					this.isOpen = true;
				}
			});
		},
		outsideClicked() {
			console.log("outside clicked!");
			if (this.isOpen) {
				this.handleCloseClick();
			}
		},
		handleCommercialClicked() {
			console.log("INSTRUCTIONS");
			if (this.$router.currentRoute.path != "/commercial") {
				this.$bus.$emit("loader/toggle", true);
				setTimeout(() => {
					this.handleCloseClick();
					this.$store.dispatch("setAppStateForPlayAgain");
					this.$store.dispatch("setRoomsDataForPlayAgain");
					this.$store.dispatch("switchBuilding", "commercial");
					this.$router.push("/commercial");
				}, 500);
			}
		},
		handleResidentialClicked() {
			console.log("INSTRUCTIONS");
			if (this.$router.currentRoute.path != "/residential") {
				this.$bus.$emit("loader/toggle", true);
				setTimeout(() => {
					this.handleCloseClick();
					this.$store.dispatch("setAppStateForPlayAgain");
					this.$store.dispatch("setRoomsDataForPlayAgain");
					this.$store.dispatch("switchBuilding", "residential");
					this.$router.push("/residential");
				}, 500);
			}
		},
		handleWinButtonClick() {
			this.$bus.$emit("show-prize-modal");
			this.handleCloseClick();
		}
	}
};
</script>

<style lang='scss' module>
@import "../assets/css/globals.scss";

.wrapper {
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;

	width: 100%;

	@include large {
		width: 435px;
	}

	display: flex;
	flex-direction: column;
	justify-content: space-between;

	background-color: rgba(255, 255, 255, 0.95);

	z-index: 775;
}

.instructions-container {
	display: flex;
	justify-content: flex-start;
	flex-direction: column;

	padding: 40px;
	padding-top: 60px;
}

.instruction-container {
	@include large {
		margin-bottom: 20px;
	}

	color: $emperor;

	list-style-position: outside;

	line-height: 1.4;
	font-weight: 300;

	// font-weight: bold;
}

.buttons-container {
	display: flex;
	flex-direction: column;
}

.close-button-container {
	position: absolute;
	top: 5px;
	left: 20px;
	padding: 20px;

	cursor: pointer;

	& svg {
		height: 15px;
		fill: #808080;
	}
}

.experience-buttons {
	display: flex;
	justify-content: space-between;
	align-items: center;

	padding-left: 40px;
	padding-right: 40px;

	padding-bottom: 40px;

	border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.win-button-container {
	display: flex;
	justify-content: center;
	align-items: center;

	margin-top: 40px;
	margin-bottom: 40px;

	@include large {
		padding-left: 40px;
		padding-right: 40px;
	}
}

.win-button {
	height: auto;
	width: 240px !important;

	padding-left: 40px;
	padding-right: 40px;
	padding-top: 20px;
	padding-bottom: 20px;

	text-align: center;
	color: white;
	font-weight: bold;
}

.hollow-commercial-button {
	margin-right: 5px;
}

.hollow-residential-button {
	margin-left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Instructions.vue